import ReactStars from "react-rating-stars-component";
//import ax111 from "assets/images/ax111.png";
import {
  Routes,
  Route,
  Router,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  useParams,
  Link,
  Switch,
} from "react-router-dom";
import sabad from "../../assets/images/logo-sabadi.png";

import { HashLink } from "react-router-hash-link";

export default function StoreList({ storeList, setSoreList, logo1, bg1 }) {
  console.log("storeList:", storeList);
  return (
    <div className="" style={{ marginTop: "150px" }}>
      <div
        className=" container p-0 d-flex justify-content-evenly flex-wrap"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        {storeList.data?.map((value, index) => {
          return (
            <HashLink
              smooth
              to={`/supplier/${value.info.suppliers__id}`}
              style={{ color: "black", textDecoration: "none" }}
            >
              <div
                className="parent-search-stor"
                style={{ width: "250px", backgroundColor: "white" }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "70px",
                    backgroundColor: "rgba(145, 140, 140, 0.2)",
                    position: "relative",
                    borderRadius: " 35px 35px 0px 0px",
                  }}
                >
                  {value.cover.path != null ? (
                    <img
                      style={{
                        width: "100%",
                        height: "140px",
                        borderRadius: " 35px 35px 0px 0px",
                        filter: " blur(1px) brightness(0.9) opacity(10)",
                      }}
                      src={`http://sabadi.tatdemo.ir/${value.cover.path}`}
                    ></img>
                  ) : (
                    <img
                      style={{
                        width: "100%",
                        height: "140px",
                        borderRadius: " 35px 35px 0px 0px",
                        filter: " blur(1px) brightness(0.9) opacity(10)",
                        backgroundColor: "red",
                      }}
                      src={bg1}
                    ></img>
                  )}

                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      backgroundColor: "white",
                      position: "absolute",
                      marginTop: "-35px",
                      marginRight: "85px",
                      border: "1px solid rgba(99, 99, 99, 0.2)",
                      padding: "5px",
                    }}
                  >
                    {value.info.path == null ? (
                      <img
                        style={{
                          width: "100%",
                          height: "70px",
                          borderRadius: "50%",
                        }}
                        src={sabad}
                      ></img>
                    ) : (
                      <img
                        style={{
                          width: "100%",
                          height: "70px",
                          borderRadius: "50%",
                        }}
                        src={`http://sabadi.tatdemo.ir/${value.info.path}`}
                      ></img>
                    )}
                  </div>
                </div>
                <div className="row mt-5 p-4">
                  <div className="col-4 mt-5 txt-title-stor">عنوان:</div>
                  <div className="col-8 mt-5 txt-value-stor">
                    {value.info.title}
                  </div>
                  <div className="col-4 mt-4 txt-title-stor">توضیحات:</div>
                  <div className="col-8 mt-4 txt-value-stor-desc">
                    {value.info.description}
                  </div>
                  <div className="col-4 mt-4 txt-title-stor">امتیاز:</div>
                  <div className="col-8 mt-4 txt-value-stor " key={index}>
                    {/* <div className="comments">
                    <div className="rate">
                      <ReactStars
                        count={5}
                        size={24}
                        isHalf={true}
                        edit={false}
                        dir={"ltr"}
                        value={value.rate}
                        emptyIcon={<i className="far fa-star"></i>}
                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                        fullIcon={<i className="fa fa-star"></i>}
                        activeColor="white"
                      />
                      <div className="valueRate">{value.score}/5</div>
                    </div>
                  </div> */}
                    {value.info.count_rate}از10
                  </div>
                </div>
              </div>
            </HashLink>
          );
        })}
      </div>
    </div>
  );
}
